<h2 mat-dialog-title>
  <mat-icon class="title-icon">{{isPlanned ? 'event_repeat' : 'build'}}</mat-icon>
  {{isEdit ? 'Auftrag bearbeiten' : (isPlanned ? 'Wartung planen' : 'Neuer Einsatz')}}
  <span class="title-customer" *ngIf="customerName"> · {{customerName}}</span>
</h2>

<mat-dialog-content>
  <div class="form-grid">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Titel / Beschreibung</mat-label>
      <input matInput [(ngModel)]="title" required
             [placeholder]="isPlanned ? 'z.B. Jährliche Wartung Hauptverteiler' : 'z.B. Störungsbehebung Sicherung'">
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Anlage / Verteiler</mat-label>
      <mat-select [(ngModel)]="selectedEquipmentId" required>
        <mat-option *ngFor="let eq of equipments" [value]="eq.id">
          {{eq.name}} <span *ngIf="eq.location" class="option-hint">– {{eq.location}}</span>
        </mat-option>
      </mat-select>
      <mat-icon matPrefix>electrical_services</mat-icon>
    </mat-form-field>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>{{isPlanned ? 'Geplantes Datum' : 'Einsatzdatum'}}</mat-label>
        <input matInput [matDatepicker]="scheduledPicker" [(ngModel)]="scheduledDate" required>
        <mat-datepicker-toggle matSuffix [for]="scheduledPicker"></mat-datepicker-toggle>
        <mat-datepicker #scheduledPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Fällig bis</mat-label>
        <input matInput [matDatepicker]="duePicker" [(ngModel)]="dueDate">
        <mat-datepicker-toggle matSuffix [for]="duePicker"></mat-datepicker-toggle>
        <mat-datepicker #duePicker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Recurrence (only for planned) -->
    <div *ngIf="isPlanned" class="section-label">Wiederholung</div>

    <mat-form-field *ngIf="isPlanned" appearance="outline" class="full-width">
      <mat-label>Intervall</mat-label>
      <mat-select [(ngModel)]="recurrenceType">
        <mat-option *ngFor="let opt of recurrenceOptions" [value]="opt.value">{{opt.label}}</mat-option>
      </mat-select>
      <mat-icon matPrefix>repeat</mat-icon>
    </mat-form-field>

    <mat-form-field *ngIf="isPlanned && isCustomRecurrence" appearance="outline" class="full-width">
      <mat-label>Intervall in Tagen</mat-label>
      <input matInput type="number" [(ngModel)]="recurrenceIntervalDays" min="1">
    </mat-form-field>

    <!-- Assignment -->
    <div class="section-label">Zuweisung & Benachrichtigung</div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Techniker zuweisen</mat-label>
      <mat-select multiple [(ngModel)]="assignedUserIds">
        <mat-option *ngFor="let user of users" [value]="user.id">{{user.userName}} <span *ngIf="user.email" class="option-hint">– {{user.email}}</span></mat-option>
      </mat-select>
      <mat-icon matPrefix>group</mat-icon>
    </mat-form-field>

    <div class="notification-row">
      <mat-slide-toggle [(ngModel)]="notificationsEnabled" color="primary">
        Erinnerungs-E-Mail senden
      </mat-slide-toggle>
      <mat-form-field *ngIf="notificationsEnabled" appearance="outline" class="small-field">
        <mat-label>Tage vorher</mat-label>
        <input matInput type="number" [(ngModel)]="notificationLeadTimeDays" min="1" max="30">
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Notizen</mat-label>
      <textarea matInput [(ngModel)]="notes" rows="3" placeholder="Zusätzliche Informationen..."></textarea>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <span class="validation-hint" *ngIf="validationHint">
    <mat-icon>info</mat-icon> {{validationHint}}
  </span>
  <button mat-button (click)="cancel()">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="save()"
          [disabled]="!title.trim() || !selectedEquipmentId || saving">
    <mat-spinner *ngIf="saving" diameter="18" class="btn-spinner"></mat-spinner>
    {{isEdit ? 'Speichern' : (isPlanned ? 'Wartung planen' : 'Einsatz erstellen')}}
  </button>
</mat-dialog-actions>
